'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ClerkProvider } from '@clerk/nextjs'
import { TooltipProvider } from '@repo/ui/tooltip'
import { useAuthProviderSetup } from '@/lib/auth-setup'
import { AuthProvider } from '@/contexts/AuthContext'
import PostHogIdentifiy from './PostHogIdentifiy'
import React from 'react'

function AuthProviderSetup() {
  useAuthProviderSetup()
  return null
}

export const Providers = ({ children }: { children: React.ReactNode }) => {
  const [queryClient] = React.useState(() => new QueryClient())

  return (
    <ClerkProvider>
      <AuthProviderSetup />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <PostHogIdentifiy />
          <TooltipProvider>{children}</TooltipProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ClerkProvider>
  )
}
